import { jsPDF } from 'jspdf';
import { formatCOP } from '../../lib/cierre/calculations';
import type { BalanceByMethod } from '../../lib/cierre/types';
import { METODOS_CIERRE, LABELS_METODO_CIERRE } from '../../lib/cierre/types';

export function downloadCierrePdf(opts: {
  titulo: string;
  periodo: string;
  empresaNombre: string;
  ingresos: BalanceByMethod;
  gastos: BalanceByMethod;
  netoPorMetodo: BalanceByMethod;
  extraLines?: string[];
}) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const margin = 48;
  let y = margin;

  doc.setFontSize(16);
  doc.text('Clientelo — Cierre de caja', margin, y);
  y += 22;
  doc.setFontSize(11);
  doc.text(opts.empresaNombre, margin, y);
  y += 16;
  doc.text(`${opts.titulo} · ${opts.periodo}`, margin, y);
  y += 14;
  doc.setFontSize(9);
  doc.text(
    `Generado: ${new Date().toLocaleString('es-CO', { timeZone: 'America/Bogota' })}`,
    margin,
    y
  );
  y += 28;

  doc.setFontSize(10);
  doc.text('Resumen por método de pago', margin, y);
  y += 16;
  doc.setFontSize(9);
  for (const m of METODOS_CIERRE) {
    const line = `${LABELS_METODO_CIERRE[m]}: Ingresos ${formatCOP(opts.ingresos[m])} · Gastos ${formatCOP(
      opts.gastos[m]
    )} · Neto ${formatCOP(opts.netoPorMetodo[m])}`;
    doc.text(line, margin, y);
    y += 12;
    if (y > 750) {
      doc.addPage();
      y = margin;
    }
  }

  if (opts.extraLines?.length) {
    y += 10;
    for (const line of opts.extraLines) {
      doc.text(line, margin, y);
      y += 12;
      if (y > 750) {
        doc.addPage();
        y = margin;
      }
    }
  }

  const safe = opts.periodo.replace(/[^0-9-]/g, '-');
  doc.save(`clientelo-cierre-${safe}.pdf`);
}
